<ng-container *ngrxLet="activeLanguage$ as activeLanguage">
    <ng-container *ngIf="activeLanguage === 'pl'">
        <p>
            <strong>
                Polska Agencja Żeglugi Powietrznej wybrała laureatów konkursu o nazwie "Rozbudowa i wyposażenie Centrów Kompetencji
                (specjalistyczne ośrodki szkoleniowe, ośrodki wsparcia wdrożeń, centra monitorowania) oraz infrastruktura do zarządzania
                ruchem pojazdów bezzałogowych jako ekosystem innowacji". Dzięki Krajowemu Planowi Odbudowy na mapie Polski powstaną
                nowoczesne ośrodki rozwoju technologii dronowych.
            </strong>
        </p>
        <p>
            Wśród zwycięzców znalazły się Centrum Kompetencji Gminy Miasta Krosno wraz z Gminami Partnerskimi, Dronowe Centrum Kompetencji
            Górnej Odry, Olsztyn z Gminą Barczewo, Przasnyska Strefa Gospodarcza, Strzelce Krajeńskie, Dolnośląska Strefa Powietrzna BSP,
            Stalowowolskie Centrum Kompetencji, Obszar Podkarpackie 1 oraz Obszar Bytom-Zabrze.
        </p>
        <p>
            Konkurs prowadzony przez Polską Agencją Żeglugi Powietrznej został zakończony. Centra Kompetencji będą środowiskami
            technologicznymi umożliwiającymi realizację dynamicznych i zaawansowanych lotów BSP na masową skalę w przestrzeni przypisanej do
            każdego z nich.
        </p>
        <p>
            Zgodnie z regulaminem konkursu zgłoszone obszary zostały oceniane w 6 kategoriach głównych. W ich skład weszły specyfika
            przestrzeni powietrznej i lokalizacja przedstawionego obszaru, gęstość zaludnienia, infrastruktura, współpraca PAŻP – Uczestnik
            oraz uwarunkowania gospodarcze. Oceny potencjału kandydatów dokonał również rynek dronowy poprzez głosowanie za pośrednictwem
            Krajowego Systemu Informacji Dronowej (<a href="https://drony.gov.pl" target="_blank" rel="noopener norefer"
                >https://drony.gov.pl</a
            >). W ten sposób wyłoniono po jednym laureacie z pięciu zdefiniowanych obszarów geograficznych oraz dodatkowych czterech
            zwycięzców Konkursu z kolejną, najwyższą liczbą punktów.
        </p>
        <p>Poniżej znajduje się lista laureatów.</p>
        <p>Zwycięzcy obszarów:</p>
        <ul>
            <li>Obszar SE - Centrum Kompetencji Gmina Miasto Krosno i Gminy Partnerskie</li>
            <li>Obszar SW - Dronowe Centrum Kompetencji Górnej Odry</li>
            <li>Obszar NE - Olsztyn, Barczewo</li>
            <li>Obszar C - Przasnyska Strefa Gospodarcza</li>
            <li>Obszar NW - Strzelce Krajeńskie</li>
        </ul>
        <p>Pozostali laureaci z największą liczbą punktów:</p>
        <ul>
            <li>Obszar Podkarpackie 1</li>
            <li>Dolnośląska Strefa Powietrzna BSP</li>
            <li>Stalowowolskie Centrum Kompetencji</li>
            <li>Obszar Bytom-Zabrze</li>
        </ul>
        <p>
            PAŻP nie wyklucza podpisania umów z pozostałymi, wybranymi uczestnikami konkursu, którzy otrzymali korzystną ocenę merytoryczną.
            Poniżej lista rezerwowa laureatów:
        </p>
        <ul>
            <li>Gmina Miasto Rzeszów;</li>
            <li>Turośń Kościelna</li>
            <li>Akademicki Ośrodek Szybowcowy Politechniki Rzeszowskiej w Bezmiechowej</li>
        </ul>
        <p>
            <em
                >"Wszystkim uczestnikom serdecznie dziękujemy za udział w konkursie, a laureatom gratulujemy wygranej. Po analizie złożonych
                wniosków można śmiało powiedzieć, że konkurs miał bardzo wysoki poziom, a rywalizacja była zacięta. Tak duże zainteresowanie
                pokazuje dynamiczny potencjał polskiego rynku dronowego. W najbliższych dniach rozpoczniemy proces podpisywania umów o
                współpracy, który potrwa około 21 dni. Zgodnie z regulaminem, jeżeli któryś z laureatów odstąpi od podpisania umowy będziemy
                kontaktować się z kolejnymi jednostkami, które wzięły udział w konkursie"</em
            >
            – mówi Michał Caban, General Project Manager BSP KPO w Polskiej Agencji Żeglugi Powietrznej.
        </p>
        <p>
            Równocześnie, w niektórych obszarach zgłoszonych przez laureatów, PAŻP planuje utworzenie Ośrodków Poligonowo–Szkoleniowych.
            Informacje o planowanych działaniach w tym zakresie będą publikowane w późniejszym czasie.
        </p>
    </ng-container>
    <ng-container *ngIf="activeLanguage === 'en'">
        <p>
            <strong>
                The Polish Air Navigation Services Agency (PANSA) has chosen the winners of the competition titled "Development and
                equipment of Competence Centers (specialized training centers, implementation support centers, monitoring centers) and
                infrastructure for Unmanned Aerial Vehicle (UAV) Traffic Management as an Innovation Ecosystem." Thanks to the National
                Recovery Plan, modern drone technology development centers will be established across Poland.
            </strong>
        </p>
        <p>
            The winners include: Competence Center of the Municipality of Krosno and Partner Municipalities, Drone Competence Center of
            Upper Oder, Olsztyn with Barczewo Municipality, Przasnysz Economic Zone, Strzelce Krajeńskie, Lower Silesian Airspace for UAVs,
            Stalowa Wola Competence Center, Podkarpackie Area 1, and Bytom-Zabrze Area.
        </p>
        <p>
            The competition organized by PANSA has concluded. The newly established Competence Centers will serve as advanced technological
            environments, enabling large-scale, dynamic UAV operations within designated airspace zones.
        </p>
        <p>
            According to the competition regulations, the submitted areas were evaluated in six main categories: airspace specifics and
            location, population density, infrastructure, PANSA–Participant cooperation, and economic conditions. The drone market also
            assessed the candidates' potential through voting via the National Drone Information System (<a
                href="https://drony.gov.pl"
                target="_blank"
                rel="noopener norefer"
                >https://drony.gov.pl</a
            >). One winner was selected from each of five defined geographical areas, with four additional winners chosen based on the
            highest overall scores.
        </p>
        <p>Below is the list of laureates.</p>
        <p>Area winners:</p>
        <ul>
            <li>SE Area – Competence Center Municipality of Krosno and Partner Municipalities</li>
            <li>SW Area – Drone Competence Center of Upper Oder</li>
            <li>NE Area – Olsztyn, Barczewo</li>
            <li>C Area – Przasnysz Economic Zone</li>
            <li>NW Area – Strzelce Krajeńskie</li>
        </ul>
        <p>Other laureates with the highest scores:</p>
        <ul>
            <li>Podkarpackie Area 1</li>
            <li>Lower Silesian Airspace for UAVs</li>
            <li>Stalowa Wola Competence Center</li>
            <li>Bytom-Zabrze Area</li>
        </ul>
        <p>
            PANSA does not exclude signing agreements with other selected competition participants who received a favorable substantive
            assessment. Below is the reserve list of laureates:
        </p>
        <ul>
            <li>Municipality of Rzeszów</li>
            <li>Turośń Kościelna</li>
            <li>Academic Glider Center of Rzeszów University of Technology in Bezmiechowa</li>
        </ul>
        <p>
            <em>
                "We sincerely thank all participants for taking part in the competition and congratulate the winners. After analyzing the
                submitted applications, it can be confidently said that the competition was of a very high level and the rivalry was fierce.
                Such great interest shows the dynamic potential of the Polish drone market. In the coming days, we will begin the process of
                signing cooperation agreements, which is expected to take approximately 21 days. According to the regulations, if any
                laureate withdraws from signing the agreement, we will contact the next entities that participated in the competition."
            </em>
            – says Michał Caban, General Project Manager UAV NRP at PANSA
        </p>
        <p>
            At the same time, in some areas submitted by the laureates, PANSA plans to establish Training and Testing Centers. Information
            about planned activities in this regard will be published soon.
        </p>
    </ng-container>
</ng-container>
